var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctorLightIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_999_4250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_999_4250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H18V18H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_999_4250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5675 2.2716C11.744 1.17356 10.4516 0.527355 9.07907 0.527355H8.9209C7.54836 0.527355 6.25595 1.17356 5.43245 2.2716L5.43231 2.27174C5.18164 2.60604 5.04608 3.01258 5.04608 3.43045V5.61091C5.04608 7.79464 6.8163 9.56483 9 9.56483C11.1837 9.56483 12.9539 7.79464 12.9539 5.61091V3.43045C12.9539 3.01258 12.8184 2.60604 12.5677 2.27174L12.5675 2.2716Z",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04608 5.04609H5.04615C5.40777 5.04609 5.75459 4.90241 6.01031 4.64675C6.33537 4.32166 6.74061 3.91641 6.74061 3.91641H6.74068C8.16296 4.62759 9.83703 4.62759 11.2593 3.91641H11.2594C11.2594 3.91641 11.6646 4.32166 11.9897 4.64675C12.2454 4.90241 12.5922 5.04609 12.9538 5.04609H12.9539",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 17.4727C17.4727 17.4727 16.7831 15.4041 16.2838 13.9061C15.9701 12.9649 15.1856 12.2574 14.2172 12.0422C12.7229 11.7101 10.6945 11.2594 10.6945 11.2594L9 14.0836L7.30547 11.2594C7.30547 11.2594 5.27709 11.7101 3.78285 12.0422C2.81443 12.2574 2.02992 12.9649 1.71619 13.9061C1.21686 15.4041 0.527344 17.4727 0.527344 17.4727",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30548 11.2594V9.27146",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6945 11.2594V9.27146",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8243 17.4727H11.2594V15.7781C11.2594 15.3287 11.4379 14.8977 11.7557 14.5799C12.0735 14.2621 12.5045 14.0836 12.9539 14.0836C13.8898 14.0836 14.6485 14.8423 14.6485 15.7781V17.4727H14.0836",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9539 13.5187V11.7615",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04612 15.2133C4.42262 15.2133 3.91644 15.7195 3.91644 16.343C3.91644 16.9665 4.42262 17.4727 5.04612 17.4727C5.66961 17.4727 6.17579 16.9665 6.17579 16.343C6.17579 15.7195 5.66961 15.2133 5.04612 15.2133Z",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04608 15.2133V11.7614",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorLightIc);
export default __webpack_public_path__ + "static/media/doctor-light-ic.f4697b5e8e638fc981a8bc2be5b224ff.svg";
export { ForwardRef as ReactComponent };